export default __webpack_public_path__ + "static/media/VolvoNovum-Regular.589f70c8.ttf";